<template>
  <div>
    <h2 class="text-[26px] font-black mb-3">{{ $t('shared.coupon_or_gift_code') }}</h2>
    <p>{{ $t("shared.discount_gift_card") }}</p>
    <div class="discount-code w-full mt-5 lg:w-1/2">
      <div class="input-group flex flex-row gap-4 items-center">
        <v-text-field
          v-model="value"
          height="45"
          class="avm-text-field lg:1/2 mb-0 grow-0"
          :class="{
            'border border-2 border-error': codeAttempted && !discountIsApplicable && value,
            'border-none': !value
          }"
          solo
          flat
          hide-details
          :disabled="discountIsApplicable"
          :outlined="!(codeAttempted && !discountIsApplicable && value)"
        ></v-text-field>
        <v-btn :disabled="buttonDisabled" height="54" width="130" outlined class="font-black" @click="applyDiscount"> {{ $t("shared.apply") }} </v-btn>
        <v-progress-circular
          class="ml-4"
          v-if="isLoading"
          indeterminate
          color="secondary"
          size="35"
        ></v-progress-circular>
        <div v-else-if="discountIsApplicable" class="ml-3">
          <v-icon color="success" size="42">mdi-check-bold</v-icon>
        </div>
        <div v-else-if="codeAttempted && !discountIsApplicable && value" class="ml-3">
          <v-icon color="error" size="42">mdi-close-thick</v-icon>
        </div>
        <p v-else-if="discountCode && !discountIsApplicable" class="discount-requirements-error ml-3">
          {{ $t("shared.insuff_amount") }}
        </p>
      </div>
      <p v-if="codeAttempted && !discountIsApplicable && value" class="pt-2.5 text-sm text-error">{{ $t("shared.discount_code_not_valid") }}</p>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import {
  GET_NIGHTS_DISCOUNT_CODE_IS_APPLICABLE,
  GET_NIGHTS_DISCOUNT_CODE,
GET_RESERVATION_ID,
} from "../../../store/nights/getter-types";
import {
  SET_NIGHTS_DISCOUNT_CODE,
} from "../../../store/nights/mutation-types";
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      value: null,
      isLoading: false,
      buttonDisabled: false,
      codeAttempted: false,
    }
  },
  computed: {
    ...mapGetters({
      discountCode: GET_NIGHTS_DISCOUNT_CODE,
      discountIsApplicable: GET_NIGHTS_DISCOUNT_CODE_IS_APPLICABLE,
      reservationId: GET_RESERVATION_ID
    }),

  },
  methods: {
    validateCode: _.debounce(function () {
      const code = this.value;
      const path = code.startsWith("GIFT-") ?
        "/api/gifts/" :
        "/coupon?discount=";

      this.isLoading = true;
      this.codeAttempted = true;

      axios
        .get(path + code)
        .then(({ data }) => {
          this.$store.commit(SET_NIGHTS_DISCOUNT_CODE, data);
          this.buttonDisabled = true
          axios.put('/api/apply-coupon', {
            discountCode: this.value,
            reservationCode: this.reservationId
          })
        })
        .catch(() => {
          this.$store.commit(SET_NIGHTS_DISCOUNT_CODE, "");
        })
        .finally(() => (this.isLoading = false));
    }, 300),
    applyDiscount() {
      this.validateCode();
    }
  },
}
</script>

